import HolidayWorkApplicationPage from './HolidayWorkApplicationPage';

export default HolidayWorkApplicationPage;
